import {useMemo} from 'react';

import {QueryResultType} from 'graphql-client/BenchlingQuery';
import {SchemaInterfaceWithFields} from 'procedures/design/utils/equipmentSchemaHelpers';
import {useAllSchemaInterfacesQuery} from 'schemas/util/useAllSchemaInterfacesQuery';

/**
 * All fieldsets with their fields, or null while they are loading
 */
export default function useSchemaInterfacesWithFields(): Array<SchemaInterfaceWithFields> | null {
  const schemaInterfacesResult = useAllSchemaInterfacesQuery();
  return useMemo(
    () =>
      schemaInterfacesResult.type === QueryResultType.SUCCESS
        ? schemaInterfacesResult.data.schemaInterfaces
        : null,
    [schemaInterfacesResult]
  );
}
